<template>
  <div>
    <div class="row m-0" style="margin: 0px -12px !important;">
      <div class="col-md-4 mb-3">
        <label for="">Tải tệp tin cần ký số</label>
        <div style="color: red">Lưu ý: Tệp tin pdf </div>
        <vue-dropzone
            id="dropzone"
            ref="myVueDropzone"
            :use-custom-slot="true"
            :options="dropzoneOptions"
            v-on:vdropzone-removed-file="removeThisFile"
            v-on:vdropzone-success="addThisFile"
        >
          <div class="dropzone-custom-content">
            <i
                class="display-1 text-muted bx bxs-cloud-upload"
                style="font-size: 70px"
            ></i>
            <h4>
              Kéo thả tệp tin hoặc bấm vào để tải tệp tin
            </h4>
          </div>
        </vue-dropzone>
      </div>
      <div class="col-md-12 p-0" v-if="pathUrl">
        <PdfEditorTest :file="infoFile" :pdf="`${pathUrl}`" />
      </div>
      <!--      <b-modal-->
      <!--          v-model="showModalClock"-->
      <!--          body-class="p-3"-->
      <!--          headerClass="justify-content-center"-->
      <!--          footerClass="bg-light py-1"-->
      <!--          centered-->
      <!--          hide-header-close-->
      <!--          no-close-on-backdrop-->
      <!--          size="md"-->
      <!--      >-->
      <!--        <template #modal-title>-->
      <!--          <div class="text-primary fw-bold text-center">-->
      <!--            <h4>Xác nhận ký tài liệu</h4>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--       <CountDownClock />-->
      <!--        <template #modal-footer="{cancel}">-->
      <!--          <b-button class="btn bg-white me-2 text-primary px-5" @click="cancel()">Đóng</b-button>-->
      <!--&lt;!&ndash;          <b-button class="btn px-5 text-white" @click="addTextSignature" style="background-color: #3082c9;">Cập nhật</b-button>&ndash;&gt;-->
      <!--        </template>-->
      <!--      </b-modal>-->
    </div>
  </div>
</template>

<script>

import appConfig from "@/app.config.json";
import vue2Dropzone from "vue2-dropzone";
import PdfEditorTest from "@/components/pdfEditor/PdfEditorTest";

export default {
  name: "thietLapKySo",
  page: {
    title: "Ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  components:{
    PdfEditorTest,
    vueDropzone: vue2Dropzone,
    // CountDownClock
  },
  computed:{
    pathUrl (){
      if(this.files && this.files.length > 0){
        if(this.files[0]){
          return this.apiUrl + 'files/view/' + this.files[0].fileId
        }

      }
      return null;
    },
    infoFile(){
      if(this.files){
        if(this.files[0])
          return this.files[0];
      }
      return null
    }
  },
  data() {
    return {
      title: "Ký số",
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 1,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".pdf",
      },
      files: null,
      showModalClock: true
    };
  },
  methods:{
    removeThisFile(file, error, xhr) {
      this.files = null;
    },
    addThisFile(file, response) {
      if (this.files == null || this.files.length <= 0) {
        this.files = [] ;
      }
      let fileSuccess = response.data;

      this.files.push(
          {
            fileId: fileSuccess.id,
            fileName: fileSuccess.fileName,
            ext: fileSuccess.ext,
            size: fileSuccess.size,
          }
      );
    },

  }
}
</script>

<style scoped>

</style>